// Self-contained "Lifecycle distribution" widget for the Lifecycle page.
// Composes the chart with the section header and the §6.3.2
// interpretation note (AT_RISK 30-50% normalcy banner).

import {
  COMMUNITY_LIFECYCLE_TREND_DAYS,
  type LifecycleResponse,
} from "@community-analytics/shared";

import { cn } from "@shared/lib";

import { LIFECYCLE_TREND_STRINGS } from "../lib/strings";

import { LifecycleTrendChart } from "./LifecycleTrendChart";
import { LifecycleTrendEmptyState } from "./LifecycleTrendEmptyState";

export interface LifecycleTrendPanelProps {
  response: LifecycleResponse;
  className?: string;
}

export function LifecycleTrendPanel({
  response,
  className,
}: LifecycleTrendPanelProps) {
  return (
    <section
      aria-labelledby="lifecycle-trend-title"
      className={cn("flex flex-col gap-3", className)}
    >
      <header>
        <h2
          id="lifecycle-trend-title"
          className="text-sm font-semibold"
        >
          {LIFECYCLE_TREND_STRINGS.title}
        </h2>
        <p className="text-xs text-muted-foreground">
          {LIFECYCLE_TREND_STRINGS.subtitle}
        </p>
      </header>
      {response.dataAvailable ? (
        <>
          <LifecycleTrendChart trend={response.trend} />
          <p
            role="note"
            className="rounded-md border border-dashed bg-muted/40 p-2 text-[11px] leading-relaxed text-muted-foreground"
          >
            {LIFECYCLE_TREND_STRINGS.interpretation}
          </p>
        </>
      ) : (
        <LifecycleTrendEmptyState
          daysWithData={response.daysWithData}
          totalDays={COMMUNITY_LIFECYCLE_TREND_DAYS}
        />
      )}
    </section>
  );
}
